// extracted by mini-css-extract-plugin
module.exports = {"detail":"concrete-detail_detail_DLQ6e","listWrap":"concrete-detail_listWrap_1-9uK"};